import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateOrderRequest, IOrder, IUpdateOrderRequest } from '../models/order';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  getOrder(id: string){
    return this.http.get<IOrder>(
      `${environment.baseUrl}/v1/orders/getOrder/${id}`
    )
  }

  listorders(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IOrder[]>>(
      `${environment.baseUrl}/v1/orders/searchorders`,
      request
    )
  }

  createOrder(request : ICreateOrderRequest){
    return this.http.post<IOrder>(
      `${environment.baseUrl}/v1/orders/createorder`,
      request
    )
  }

  updateOrderState(request : IUpdateOrderRequest){
    return this.http.post<IOrder>(
      `${environment.baseUrl}/v1/orders/updateOrderState`,
      request
    )
  }
}
